import { Fragment, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import RouteMap from '../../components/RouteMap';
import { Flex, Box } from 'theme-ui';

const MapContainer = () => {
  const { t } = useTranslation();
  const { trackingDetails } = useContext(AppContext);
  dayjs.extend(calendar);

  const getTimeDiff = (dateTime: Date) => {
    let hourlyDiff = dayjs(dateTime).diff(dayjs(), 'hour');
    let minutesDiff = dayjs(dateTime).diff(dayjs(), 'minute') - hourlyDiff * 60;
    let diffString = '';

    diffString = hourlyDiff > 0 ? hourlyDiff + ' ' + t('delivery_hours') : '';

    if (hourlyDiff <= 0 && minutesDiff <= 1) {
      return '~1 ' + t('delivery_minutes');
    }

    return '~' + diffString + (minutesDiff > 0 ? minutesDiff + ' ' + t('delivery_minutes') : '');
  };

  return (
    <Fragment>
      {trackingDetails?.announcement && (
        <Flex sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px' }}>
          <Box className="announcement-box">
            <span role="img" aria-label="Warning">⚠️</span>
            <span className="blink-text">{trackingDetails?.announcement}</span>
          </Box>
        </Flex>
      )}
      <RouteMap />
      <div className="map_summary">
        {trackingDetails?.eta?.predictedArrival ? (
          <div>
            <p style={{ marginBottom: 5 }}>{t('map_summary')}</p>
            <h2 style={{ marginBottom: 15 }}>
              <b>{getTimeDiff(trackingDetails?.eta?.predictedArrival)}</b>
            </h2>
            {trackingDetails?.stopsAhead ? (
              <p style={{ marginBottom: 10, fontSize: 13 }}>
                {trackingDetails?.rider?.name + t('map_paragraph_one_suffix') + trackingDetails.stopsAhead + t('map_paragraph_one_prefix')}
              </p>
            ) : (
              <p style={{ marginBottom: 10, fontSize: 13 }}>
                {trackingDetails?.rider?.name
                  ? t('map_paragraph_two_suffix') + trackingDetails?.rider?.name + t('map_paragraph_two_prefix')
                  : t('map_paragraph_three')}
              </p>
            )}
          </div>
        ) : (
          <span style={{ fontSize: '18px', color: 'red', marginBottom: 20 }}>{t('eta.eta_error')}</span>
        )}
      </div>
    </Fragment>
  );
};

export default MapContainer;
